<template>
  <CDropdown
    inNav
    class="c-header-nav-items"
    placement="bottom-end"
    add-menu-classes="pt-0">

    <template #toggler>
      <CHeaderNavLink>
        <div class="c-avatar">
          <img
            src="img/avatars/empty_avatar.jpg"
            class="c-avatar-img "
          />
        </div>
      </CHeaderNavLink>
    </template>

    <CDropdownHeader
      tag="div"
      class="text-center"
      color="light">
      <strong>Profile</strong>
    </CDropdownHeader>
    <CDropdownItem>
      <CIcon name="cil-user" />
      <router-link to="/profile" class="profile-link">Profile</router-link>
    </CDropdownItem>
    <CDropdownItem>
      <CIcon name="cil-account-logout" />
      <router-link to="/logout" class="profile-link">Logout</router-link>
    </CDropdownItem>
  </CDropdown>
</template>

<script>
export default {
  name: 'TheHeaderDropdownProfile',
  data () {
    return {
      itemsCount: 42
    }
  }
}
</script>

<style scoped>
  .c-icon {
    margin-right: 0.3rem;
  }

  .profile-link {
    color: #fff;
    text-decoration: none;
  }

  .profile-link:hover {
    color: #fff;
    text-decoration: none;
  }
</style>
